enum WorkspaceProjectAiReportAssistantDocumentStatus {
  Active = 'Active',
  Archived = 'Archived',
}

export default WorkspaceProjectAiReportAssistantDocumentStatus
